// extracted by mini-css-extract-plugin
export default {"summaryTable":"styles_summaryTable__H-Ve8"};